import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { Image, Languages, Type, Landmark, Grid3x3, Users, ClipboardList, LogOut, Scale } from "lucide-react";
import { useAdmin } from "@/admin/AdminContext";

const NAV = [
  ["artworks", "Artworks", Image], ["languages", "Languages", Languages], ["texts", "Interface texts", Type], ["legal", "Legal pages", Scale], ["exhibitions", "Exhibitions", Landmark],
  ["matrix", "Missing content", Grid3x3], ["admins", "Admins", Users], ["signups", "Sign-ups", ClipboardList],
];

export default function AdminLayout() {
  const { admin, signOut } = useAdmin();
  if (admin === null) return <div className="min-h-screen flex items-center justify-center text-xs tracking-[0.3em] uppercase text-[var(--muted)]">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return (
    <div className="min-h-screen md:grid md:grid-cols-[220px_1fr]" data-testid="admin-layout">
      <aside className="border-b md:border-b-0 md:border-r border-[var(--line)] p-3 md:p-6 flex flex-wrap md:flex-col gap-1 md:sticky md:top-0 md:h-screen" data-testid="admin-nav">
        <Link to="/" className="hidden md:block mb-6"><span className="text-[0.6rem] tracking-[0.3em] uppercase text-[var(--muted)] block">Banksy Guide</span><span className="font-display text-2xl uppercase">Admin</span></Link>
        {NAV.map(([to, label, Icon]) => (
          <NavLink key={to} to={to} data-testid={`admin-nav-${to}`} className={({ isActive }) => `flex items-center gap-2 md:gap-3 px-3 py-2 text-xs md:text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[var(--surface-2)] text-white" : "text-[var(--muted)] hover:text-white"}`}>
            <Icon size={15} /> {label}
          </NavLink>
        ))}
        <div className="md:mt-auto flex md:flex-col gap-2 md:pt-6 md:border-t border-[var(--line)] items-center md:items-stretch">
          <span className="hidden md:block text-xs text-[var(--muted)] truncate" data-testid="admin-current-email">{admin.email}</span>
          <button type="button" onClick={signOut} className="flex items-center gap-2 px-3 py-2 text-xs md:text-sm text-[var(--muted)] hover:text-white whitespace-nowrap" data-testid="admin-logout"><LogOut size={15} /> Sign out</button>
        </div>
      </aside>
      <main className="p-5 md:p-10 max-w-6xl w-full min-w-0"><Outlet /></main>
    </div>
  );
}

export function PageTitle({ children, action }) {
  return <div className="flex flex-wrap items-start justify-between gap-4 mb-8"><h1 className="font-display text-3xl sm:text-4xl uppercase">{children}</h1>{action}</div>;
}

export function Field({ label, htmlFor, children, hint }) {
  return <div><label className="label" htmlFor={htmlFor}>{label}</label>{children}{hint && <p className="text-[0.65rem] text-[var(--muted)] mt-1">{hint}</p>}</div>;
}
